module.exports = __webpack_public_path__ + "img/SW.bcca23fe.svg";